import React, { Component } from "react";

import Paper from "@material-ui/core/Paper";
import { Input } from "../../forms/input";
import Signbutton from "../../forms/button";
import { connect } from "react-redux";
import { getNewPurchaseFundList, checkKyc } from "../../../store/actions";
import { EKYCMail } from "../../../store/actions/investors";
import CustomizedSelect from "./customizedSelect";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";

import { KycNotDoneDialog } from "../customModal";
import { BajajFund } from "../nav";
import CustomLoader from "../../forms/Loader";

class EKYC extends Component {
  constructor(props) {
    super(props);
    const { match } = this.props;
    this.state = {
      kycType: { value: "" },
      display: false,
      ipv: { value: "YES", errorMessage: "" },
      messageAlert: "",
      open: false,
      pan: {
        value:
          !!match && !!match.params && !!match.params.pan
            ? match.params.pan
            : "",
      },
      fund: { value: { value: "189" } },
      name: { value: "" },
      email: { value: "" },
      mobile: { value: "" },
    };
  }

  handleChange = (value) => {
    this.setState({
      fund: { value: { value: "189" } },
      pan: { value: this.state.pan.value },
    });
  };

  changeValue = (label) => (event) => {
    if (label === "pan" && event.target.value.length < 11) {
      if (/^[a-zA-Z0-9]*$/.test(event.target.value)) {
        this.setState({
          [label]: { value: event.target.value.toUpperCase() },
        });
      } else if (!event.target.value) {
        this.setState({
          [label]: { value: event.target.value },
        });
      }
    } else if (label === "name") {
      if (/^[a-zA-Z ]*$/.test(event.target.value)) {
        this.setState({
          [label]: { value: event.target.value },
        });
      }
    } else if (label === "mobile" && event.target.value.length < 11) {
      this.setState({
        [label]: { value: event.target.value },
      });
    } else if (label != "pan" && label != "mobile" && label != "name") {
      this.setState({
        [label]: { value: event.target.value },
      });
    }
  };

  submit = async () => {
    const { ipv, open, messageAlert, fund, display, ...others } = this.state;
    const keys = Object.keys(others);

    const findError = keys.every((key) => !!others[key].value);

    if (!findError) {
      keys.forEach((key) => {
        !others[key].value &&
          this.setState({
            [key]: {
              ...others[key],
              isError: true,
              errorMessage: `${[
                key === "kycType"
                  ? "KYC Type"
                  : key === "pan"
                  ? "PAN"
                  : key === "name"
                  ? "Name"
                  : key === "email"
                  ? "Email Id"
                  : key === "mobile"
                  ? "Phone"
                  : "",
              ]} is mandatory`,
            },
          });
      });
      return;
    } else if (
      !/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/.test(this.state.pan.value)
    ) {
      this.setState({
        pan: {
          value: "",
          isError: true,
          errorMessage: "Please enter a valid PAN",
        },
      });
    } else if (
      this.state.email.value === "" ||
      /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
        this.state.email.value
      ) === false
    ) {
      if (this.state.email.value === "") {
        this.setState({
          email: {
            isError: true,
            errorMessage: `Email ID is mandatory`,
          },
        });
      } else if (
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
          this.state.email.value
        ) === false
      ) {
        this.setState({
          email: {
            value: "",
            isError: true,
            errorMessage: `Enter a valid Email ID`,
          },
        });
      }
    } else if (this.state.name.value === "") {
      this.setState({
        name: {
          isError: true,
          errorMessage: "Name is mandatory",
        },
      });
    } else if (
      this.state.mobile.value === "" ||
      /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6-9]\d{9}$/.test(
        this.state.mobile.value
      ) === false
    ) {
      if (this.state.mobile.value === "") {
        this.setState({
          mobile: {
            isError: true,
            errorMessage: `Phone no is mandatory`,
          },
        });
      } else if (
        /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6-9]\d{9}$/.test(
          this.state.mobile.value
        ) === false
      ) {
        this.setState({
          mobile: {
            isError: true,
            errorMessage: `Enter a valid Phone number`,
          },
        });
      }
    } else if (
      this.state.ipv.value === "NO" &&
      this.state.kycType.value === "DKYC"
    ) {
      this.setState({
        ipv: {
          value: "NO",
          // isError: true,
          errorMessage: "It is mandatory to perform IPV to proceed",
        },
      });
    } else {
      if (this.state.kycType.value === "IKYC") {
        this.setState({
          display: true,
        });
        const { fund, name, email, mobile, pan } = this.state;
        const url = `https://mfs.kfintech.com/ckyc/eKyc.aspx?UserID=3677&AgencyCode=189&AgencyTransactionID=9999&Pan=${pan.value}&PanName=${name.value}&Mobile=${mobile.value}&EmailID=${email.value}&AuthType=3&ipv=n&EmpName=${this.props.userId}&EmpDesig=Manager&EmpCode=${this.props.token}&EmpLoc=Hyderabad&FundCode=189&fromType=BAJAJ`;

        const params = {
          InvPan: this.state.pan.value,
          InvMobile: mobile.value,
          InvFund: "189",
          customfund: "189",
          InvName: name.value,
          DistUserId: this.props.userId,
          Url: url,
          InvEmail:this.state.email.value,
          DistName: this.props.userId,
          ArnCode: this.props.token,
        };
        const response = await this.props.EKYCMail(params);
        if (response && !response.error) {
          this.setState({
            display: false,
            open: true,
            messageAlert:
              "An Mail will be triggered to investor's email for uploading neccesary KYC documents and selfie video.please confirm",
          });
        }
      } else {
        const { email, mobile, name } = this.state;
        window.open(
          `https://mfs.kfintech.com/ckyc/eKyc.aspx?UserID=3677&AgencyCode=189&AgencyTransactionID=9999&Pan=${this.state.pan.value}&PanName=${name.value}&Mobile=${mobile.value}&EmailID=${email.value}&AuthType=3&ipv=n&EmpName=${this.props.userId}&EmpDesig=Manager&EmpCode=${this.props.token}&EmpLoc=Hyderabad&FundCode=189&fromType=BAJAJ`,
          "_self"
        );
      }
    }
  };

  continue = () => {
    const { params } = this.props.match;
    this.setState({
      kycType: { value: "" },
      ipv: { value: "YES", errorMessage: "" },
      fund: { value: "" },
      pan: { value: !!params && !!params.pan ? params.pan : "" },
      open: false,
      messageAlert: "",
      name: { value: "" },
      email: { value: "" },
      mobile: { value: "" },
    });
    this.props.history.push("/dashboard");
  };

  handleChangeKycType = (event) => {
    const { match } = this.props;
    this.setState({
      kycType: { value: event.target.value },
      ipv: { value: "YES", errorMessage: "" },
      fund: { value: "" },
      pan: {
        value:
          !!match && !!match.params && !!match.params.pan
            ? match.params.pan
            : "",
      },
      name: { value: "" },
      email: { value: "" },
      mobile: { value: "" },
    });
  };

  handleKycStatus = async () => {
    if (
      this.state.pan.value.charAt(3) !== "P" &&
      this.state.pan.value.length === 10
    ) {
      this.setState({
        pan: {
          value: "",
          isError: true,
          errorMessage:
            "Entered PAN Number is not related to Individual PAN Number, So please Enter Individual PAN Number",
        },
      });
      return;
    } else {
      if (this.state.pan.value.length === 10) {
        this.setState({
          display: true,
        });
        const kycResponse = await this.getKycDetails(this.state.pan.value);
        if (kycResponse) {
          const {
            DtData: [info],
          } = kycResponse;
          if (!!info && !!info.KYCBlock && info.KYCBlock === "N") {
            alert("PAN is KYC Registered");
            this.setState({
              pan: { value: "" },
              display: false,
            });
          } else {
            this.setState({
              display: false,
            });
          }
        }
      }
    }
  };

  getKycDetails = async (pan) => {
    const params = {
      i_pan: pan,
      fund: "189",
      userid:this.props.userId,
    };
    const kycResponse = await this.props.checkKyc(params);
    return kycResponse;
  };

  render() {
    const { fundsList } = this.props;
    const { fund, email, name, mobile, kycType, display } = this.state;
    return (
      <div className="container-margin">
        <CustomLoader display={!!display} />
        <div className="investor-title">e-KYC Form</div>
        <Paper
          className="digital-form-container ekyc-paper"
          style={{
            boxShadow: "0px 0px 2px 0px lightgray",
            marginLeft: 0,
            marginRight: 0,
            marginTop: 20,
          }}
        >
          <div
            className="digital-form-Right-div "
            style={{ borderLeft: 0, background: "transparent" }}
          >
            <div className="transaction-details">
              <div className="input-margin flex ekyc">
                <div className="appbar-div dual-margin ekycFund">
                  <div className="input-name">AMC</div>
                  <BajajFund />
                </div>
                <div className="appbar-div dual-margin ">
                  <CustomizedSelect
                    name="KYC Type"
                    handleChange={this.handleChangeKycType}
                    value={kycType.value}
                    isError={kycType.isError}
                    errorMessage={kycType.errorMessage}
                    isShowError={kycType.isError}
                    placeholder="Select KYC Type"
                  >
                    <MenuItem value="DKYC" key="DKYC" className="menuItem">
                      Distributor (EKYC)
                    </MenuItem>
                    <MenuItem value="IKYC" key="IKYC">
                      Online IPV with Esign
                    </MenuItem>
                  </CustomizedSelect>
                  <div
                    style={{
                      fontSize: 14,
                      color: "red",
                    }}
                  >
                    {this.state.kycType.value === "IKYC"
                      ? ""
                      : this.state.kycType.value === "DKYC"
                      ? "Investor Presence Required *"
                      : ""}
                  </div>
                </div>
              </div>
              <div className="input-margin flex ekyc">
                <div className="appbar-div dual-margin ">
                  <div className="input-name">PAN</div>
                  <div style={{ marginTop: 10 }}>
                    <Input
                      name=""
                      onChange={this.changeValue("pan")}
                      onBlur={this.handleKycStatus}
                      value={this.state.pan.value}
                      isShowError={this.state.pan.isError}
                      errorMessage={this.state.pan.errorMessage}
                      disabled={
                        !!this.props.match &&
                        !!this.props.match.params &&
                        !!this.props.match.params.pan
                          ? true
                          : false
                      }
                    />
                  </div>
                </div>
                <div className="appbar-div dual-margin">
                  <div className="input-name">Name</div>
                  <div style={{ marginTop: 10 }}>
                    <Input
                      name=""
                      onChange={this.changeValue("name")}
                      value={name.value}
                      isShowError={name.isError}
                      errorMessage={name.errorMessage}
                    />
                  </div>
                </div>
              </div>

              <div className="input-margin flex ekyc">
                <div className="appbar-div dual-margin ">
                  <Input
                    name="Email ID"
                    onChange={this.changeValue("email")}
                    value={email.value}
                    isShowError={email.isError}
                    errorMessage={email.errorMessage}
                  />
                </div>
                <div className="appbar-div dual-margin ">
                  <Input
                    name="Phone"
                    onKeyDown={(evt) =>
                      (evt.key === "e" || evt.key === "." || evt.key === "-") &&
                      evt.preventDefault()
                    }
                    type="number"
                    onChange={this.changeValue("mobile")}
                    value={mobile.value}
                    isShowError={mobile.isError}
                    errorMessage={mobile.errorMessage}
                  />
                </div>
              </div>

              {this.state.kycType.value === "IKYC" && (
                <div className="instructions-box">
                  <div className="instruction-title">Instructions Box</div>
                  <ul>
                    <li className="instruction-mode">
                      This process will send an email to your client for
                      completing KYC process
                    </li>
                    <li className="instruction-mode">
                      Your client has to upload relevant documents and record a
                      video of self by showing the documents.
                    </li>
                    <li className="instruction-mode">
                      Please inform and guide your client accordingly.
                    </li>
                  </ul>
                </div>
              )}
              {/* 
              {this.state.kycType.value === "DKYC" && (
                <div className="input-margin flex ekyc">
                  <div className="appbar-div dual-margin">
                    <div
                      style={{ fontSize: 15, fontFamily: "Rubik-Regular" }}
                    >
                      Required Documents
                    </div>
                    <ul
                      className="redemption-details"
                      style={{
                        color: "#005DAC",
                        backgroundColor: "#fefbf7",
                        fontFamily: "Rubik-Regular",
                        lineHeight: 5,
                      }}
                    >
                      <li>Aadhaar XML or PDF File</li>
                      <li>Share code</li>
                    </ul>
                  </div>
                  <div className="appbar-div dual-margin ">
                    <div
                      style={{ fontSize: 15, fontFamily: "Rubik-Regular" }}
                    >
                      <span className="ekyc-check">
                        <Checkbox checked={true} />
                      </span>{" "}
                      Perform Inperson Verification (IPV)
                    </div>
                  </div>
                </div>
              )} */}

              {this.state.kycType.value === "DKYC" && (
                <div className="instructions-box">
                  <div className="instruction-title">Instructions Box</div>
                  <ul>
                    <li className="instruction-mode">
                      This process is based on e-Aadhaar, please keep the masked
                      e-Aadhaar copy and password ready before initiating.
                    </li>
                    <li className="instruction-mode">
                      First investment is allowed only towards the fund
                      selected.
                    </li>
                  </ul>
                </div>
              )}

              <div className="digital-form-button-next-div">
                <Signbutton buttontitle="Submit" onClick={this.submit} />
              </div>
              <KycNotDoneDialog
                message={this.state.messageAlert}
                open={this.state.open}
                continue={this.continue}
              />
            </div>
          </div>
        </Paper>
      </div>
    );
  }
}

export default connect(
  ({ authReducer, transactions }) => {
    const { token, userId } = authReducer;
    const { fundsList = [] } = transactions;
    return {
      token,
      userId,
      fundsList,
    };
  },
  { getNewPurchaseFundList, EKYCMail, checkKyc }
)(EKYC);
